import { writable } from 'svelte/store';
export const categories = writable([]);
export const isShowLoader = writable(true);
export const branches = writable([]);
export const selectedBranch = writable(null);
